import { css } from "@compiled/react";
// @ts-ignore
import { useInView } from "react-intersection-observer";
import { useIntl } from "react-intl";

import {
    JiraOverlayTemplate,
    JPDOverlayTemplate
} from "@/components/signup/layouts/product-overlay-template";
import SiteActivation, {
    UpgradeEligibleUser
} from "@/components/signup/site-activation";
import {
    useCohort,
    useLoggedInHasJira,
    useUserContext
} from "@/components/user-context";
import type { ExistingSite } from "@/libraries/bxp-web-stargate-client/src";

import { SubmitButtonMessageNext } from "../../../components";
import { WelcomeBackHeading } from "../../../loom/components";
import { useGetExistingSites } from "../../../utils/get-existing-sites";
import { LoggedInJpdNewUser } from "../free/new-user";

export const LoggedInJpdPremium = () => {
    const { ref } = useInView();
    const cohort = useCohort();
    const isLoggedInHasJira = useLoggedInHasJira();

    // Upgradeable Standard Sites Experiment
    const existingSites = useGetExistingSites();

    if (cohort === "new-user") {
        return <LoggedInJpdNewUser />;
    }

    if (isLoggedInHasJira) {
        return (
            <div ref={ref}>
                <JiraOverlayTemplate size="sm">
                    <Content existingSites={existingSites} />
                </JiraOverlayTemplate>
            </div>
        );
    }

    return (
        <div ref={ref}>
            <JPDOverlayTemplate size="sm">
                <Content existingSites={existingSites} />
            </JPDOverlayTemplate>
        </div>
    );
};

const Content = ({ existingSites }: { existingSites?: ExistingSite[] }) => {
    const {
        user: { name }
    } = useUserContext();

    const { formatMessage } = useIntl();

    const siteActivationContent = existingSites ? (
        <UpgradeEligibleUser SubmitButton={<SubmitButtonMessageNext />} />
    ) : undefined;

    return (
        <>
            <h1 css={headerCss}>
                <WelcomeBackHeading name={name} />
            </h1>
            <h2 css={subheadingCss}>
                {formatMessage({
                    id: "LoomTemplate.loggedInHero.subheader",
                    defaultMessage:
                        "Sites are shared spaces to organize work, teams, and projects."
                })}
            </h2>
            <SiteActivation
                existingSites={existingSites}
                UpgradeEligibleUser={siteActivationContent}
                CurrentProductUser={siteActivationContent}
                WeekOneUser={siteActivationContent ?? null}
            />
            <footer css={footerCss}>
                {formatMessage({
                    id: "JiraSoftwarePageTemplate.loggedInHero.recatcha",
                    defaultMessage:
                        "This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply."
                })}
            </footer>
        </>
    );
};

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const subheadingCss = css({
    fontSize: 16,
    fontWeight: 400,
    textAlign: "center",
    lineHeight: "24px",
    fontFamily: "Charlie Text",
    margin: "16px 0 0"
});

const footerCss = css({
    fontSize: 12,
    fontWeight: 400,
    margin: 0,
    fontFamily: "Charlie Text"
});
